import styled from 'styled-components';

interface SizedBoxProps {
  width?: number;
  height?: number;
  flexGrow?: number;
}

const SizedBox = styled.div<SizedBoxProps>`
  flex-grow: ${(props) => props.flexGrow ?? 0};
  width: ${(props) => `${props.width}px`};
  height: ${(props) => `${props.height}px`};
  flex-basis: ${(props) =>
    props.width !== undefined ? `${props.width}px` : `${props.height}px`};
  min-width: ${(props) => `${props.width}px`};
  min-height: ${(props) => `${props.height}px`};
`;

export default SizedBox;
